export const checkIsOptionalDomain = {
  methods: {
    checkIsOptionalDomain(domain, type) {
      const optionalDomain = [
        'The Child as Communicator (English)',
        'The Child as Communicator (Mandarin)',
        'Translation of "The Child as Communicator" (online translator)',
      ]
      const isOptional = optionalDomain.find(d => d === domain)
      let isCommented = false

      if (this.mode === 'Draft') {
        return true
      }

      if (isOptional) {
        this.userFlow.forEach(d => {
          if (d.Type === 'Creator' || d.Type === 'Main') {
            const comment = this.getCommentByDomain(type === 'single' ? '' : domain, type, d.ConID)
            if (comment?.[0]?.TeRpCMComment) {
              isCommented = true
            }
          }
        })
      } else if (type === 'single') {
        const singleList = []
        this.userFlow.forEach(d => {
          const comment = this.getCommentByDomain('', type, d.ConID)
          if (comment?.[0]?.TeRpCMComment) {
            singleList.push(comment?.[0]?.TeRpCMComment)
          }
        })
        isCommented = !!singleList.length
      } else {
        isCommented = true
      }

      return isCommented
    },
  },
}
